import { connect } from "react-redux";

import * as actions from "./actions";
import LayoutComponent from "./LayoutComponent";
import { withRouter } from "react-router";

const mapStateToProps = (state) => {
  return {
    sidebarIsVisible: state.layout.sidebarIsVisible,
    partyName: state.party.partyName,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleSidebar: () => dispatch(toggleSidebar()),
  };
};

const toggleSidebar = () => {
  return { type: actions.TOGGLE_SIDEBAR };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(LayoutComponent),
);
